import gql from 'graphql-tag';


const UPDATE_BRAND_PRESET = gql`
  mutation updateBrandPreset($input: BrandPresetUpdateInput!) {
    updateBrandPreset(input: $input) {
      name
      organisationId
      brandPresetId
    }
  }
`;

const createBrandPresetMutation = () => ({
  mutation: UPDATE_BRAND_PRESET,
  module: 'organisations',
  buildVariables: (input) => ({
    input
  })
});

export default createBrandPresetMutation;